const genNewRichText = (currentRichTextImageAsDomElement, currentRichTextImage, key, value) => {
  const divEl = document.createElement('div');
  if (currentRichTextImageAsDomElement) {
    const imgEl = currentRichTextImageAsDomElement;
    imgEl.setAttribute(key, value);
    divEl.appendChild(imgEl);
  }
  const newContent = divEl.innerHTML;
  return {
    richText: Object.assign({}, currentRichTextImage, {
      content: newContent
    })
  };
};
export default genNewRichText;